import { Injectable, inject } from '@angular/core';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { Store } from '@ngrx/store';
import { Observable, of, take } from 'rxjs';

import { GeneralGenericQuestionsWithStatus } from 'src/app/tga/shared/models/models';
import { selectGenericGeneralQuestions } from 'src/app/tga/store/tga.selectors';

import {
  PotatoType,
  TgaInputType,
  TGAQuestion,
  TGARadioButtonQuestion,
  TGAWarningMessageQuestion,
} from '../../../models/question-models';

@Injectable({
  providedIn: 'root',
})
export class GenericGeneralQuestionsService {
  readonly store = inject(Store);

  public readonly cropVarietyKey = 'variety';
  public readonly potatoTypeKey = 'potatoType';
  public readonly exportKey = 'export';
  tgaState$: Observable<GeneralGenericQuestionsWithStatus | null> = of();
  public genericGeneralQuestions: TGAQuestion<TgaInputType>[] = [];
  readonly isAtLeastAdvisor$ = this.store.select(AuthorizationSelectors.hasAtLeastAdvisorRoleForApplicationKey('TGACA'));

  initializeGeneralQuestions(): void {
    this.isAtLeastAdvisor$.pipe(take(1)).subscribe((isAdvisor) => {
      this.getQuestions(isAdvisor).subscribe((questions) => {
        this.genericGeneralQuestions = questions;
      });
    });
  }

  initValues(): TGAQuestion<TgaInputType>[] {
    this.tgaState$ = this.store.select(selectGenericGeneralQuestions);
    this.tgaState$.subscribe((withStatus) => {
      const state = withStatus?.genericGeneral;
      if (state) {
        for (const question of this.genericGeneralQuestions) {
          if (question.key === this.potatoTypeKey) {
            question.value = state.targetPurpose;
          } else if (question.key === this.exportKey) {
            question.value = state?.targetExport === null
              ? undefined
              : state?.targetExport ? 'yes' : 'no';
          }
        }
      }
    });
    return this.genericGeneralQuestions;
  }

  getQuestions(_isAdvisor: boolean): Observable<TGAQuestion<TgaInputType>[]> {
    const potatoTypeOptions = Object.entries(PotatoType).map(([key, value]) => ({
      key,
      value,
    }));

    return of([
      new TGAWarningMessageQuestion({
        key: this.cropVarietyKey,
        label: 'TGA.Questionnaire.Generic.General.Variety.Question',
        placeholder: _isAdvisor ? 'TGA.Questionnaire.Generic.General.Variety.Placeholder' : 'TGA.Questionnaire.Generic.General.Variety.PlaceholderCustomer',
        required: false,
        order: 1,
      }),
      new TGARadioButtonQuestion({
        key: this.potatoTypeKey,
        label: 'TGA.Questionnaire.Generic.General.PotatoType.Question',
        required: true,
        order: 2,
        options: potatoTypeOptions,
      }),
      new TGARadioButtonQuestion({
        key: this.exportKey,
        label: 'TGA.Questionnaire.Generic.General.Export.Question',
        required: true,
        order: 3,
        options: [
          { key: 'yes', value: 'TGA.Questionnaire.Generic.General.Export.Yes' },
          { key: 'no', value: 'TGA.Questionnaire.Generic.General.Export.No' },
        ],
      }),
    ]);
  }
}
